export default {
  title: 'How Estimator24 Works',
  steps: [
    {
      title: 'Market Analysis',
      description: 'The model analyzes prices and trends in the city'
    },
    {
      title: 'Valuation',
      description: 'You receive an automatic property valuation'
    },
    {
      title: 'Analytics',
      description: 'Additionally, you see comparisons, charts, and recommendations'
    },
    {
      title: 'Decision',
      description: 'Based on the data, you make an investment or personal decision'
    }
  ]
}
